import {
  useToastController,
  Toast, ToastTitle, ToastBody,
  type ToastIntent,
} from '@fluentui/react-components';
import { createElement } from 'react';

// ---------------------------------------------------------------------------
// useToast — convenience wrapper for FluentUI Toaster
// ---------------------------------------------------------------------------
// dispatchToast() expects a React element, not a plain object.
// We build the <Toast> node here so callers just do:
//   toast.success('Guardado');
//   toast.error('Error al conectar', 'Verifica tu red.');
// ---------------------------------------------------------------------------

export function useToast() {
  const { dispatchToast } = useToastController('agrovid-toaster');

  const notify = (title: string, body?: string, intent: ToastIntent = 'info') => {
    const content = createElement(
      Toast,
      null,
      createElement(ToastTitle, null, title),
      body ? createElement(ToastBody, null, body) : null,
    );
    dispatchToast(content, { intent, pauseOnHover: true, timeout: 4000 });
  };

  return {
    success: (title: string, body?: string) => notify(title, body, 'success'),
    error:   (title: string, body?: string) => notify(title, body, 'error'),
    warn:    (title: string, body?: string) => notify(title, body, 'warning'),
    info:    (title: string, body?: string) => notify(title, body, 'info'),
  };
}
